import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { LoginRequest } from '../models/login-request.model';
import { LoginResponseDto } from '../models/login-response.dto';
import { OAUTH_CLIENT_ID, OAUTH_CLIENT_SECRET, TOKEN_ENDPOINT } from '../../../core/auth/auth.constants';

@Injectable({ providedIn: 'root' })
export class AuthApi {
  private readonly http = inject(HttpClient);

  login(payload: LoginRequest): Observable<LoginResponseDto> {
    const body = new HttpParams()
      .set('grant_type', 'password')
      .set('username', payload.username)
      .set('password', payload.password)
      .set('client_id', OAUTH_CLIENT_ID)
      .set('client_secret', OAUTH_CLIENT_SECRET);

    return this.http.post<LoginResponseDto>(TOKEN_ENDPOINT, body.toString(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  }

  refresh(refreshToken: string): Observable<LoginResponseDto> {
    const body = new HttpParams()
      .set('grant_type', 'refresh_token')
      .set('refresh_token', refreshToken)
      .set('client_id', OAUTH_CLIENT_ID)
      .set('client_secret', OAUTH_CLIENT_SECRET);

    return this.http.post<LoginResponseDto>(TOKEN_ENDPOINT, body.toString(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  }

  changePassword(password: string): Observable<{ must_change_password: boolean }> {
    return this.http.post<{ must_change_password: boolean }>('/api/auth/api/password/change/', { password });
  }
}
